import { STATS } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section className="relative flex min-h-[720px] w-full items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20editorial%20backdrop%20of%20a%20cinematic%20entertainment%20stage%20with%20deep%20terracotta%20and%20amber%20spotlight%20glow%2C%20soft%20golden%20bokeh%20particles%2C%20faint%20clipping%20paper%20shadows%20and%20hanging%20stage%20lights%20around%20the%20edges%2C%20dark%20moody%20lower%20third%20for%20readability%2C%20premium%20magazine%20cover%20aesthetic%2C%20rich%20texture%2C%20no%20text%2C%20no%20people%20faces&width=1920&height=1080&seq=hero-guagua&orientation=landscape"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/60 to-foreground-950/80" />

      <div className="relative z-10 flex w-full flex-col items-center px-4 py-28 text-center md:px-6">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-300/50 bg-accent-500/20 px-4 py-1.5 text-xs font-bold tracking-wide text-accent-100">
          <i className="ri-fire-line" />
          今日瓜田持续更新 · 追更不迷路
        </span>

        <h1 className="mt-7 max-w-5xl font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
          一次看完<em className="not-italic text-accent-300">完整吃瓜事件</em>
          <br />
          从起因到收尾，全在一条时间线上
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          今日吃瓜事件盘点与合集，帮明星瓜与行业瓜按事件顺序排好脉络。新瓜不迷路、老瓜能补齐，找回线索路径更清晰——这里是所有想一口气吃完整瓜的新老粉的入口。
        </p>

        <div className="mt-9 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#hot"
            className="flex w-full items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-8 py-3.5 text-sm font-bold text-background-50 shadow-soft transition-colors hover:bg-primary-600 sm:w-auto"
          >
            看今日热点
            <i className="ri-arrow-right-line ml-2" />
          </a>
          <a
            href="#collections"
            className="flex w-full items-center justify-center whitespace-nowrap rounded-full border border-background-100/40 bg-background-50/5 px-8 py-3.5 text-sm font-bold text-background-50 backdrop-blur transition-colors hover:bg-background-100/15 sm:w-auto"
          >
            <i className="ri-list-check-2 mr-2" />
            逛整瓜合集
          </a>
        </div>

        <div className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="flex flex-col items-center rounded-2xl border border-background-100/15 bg-background-50/5 px-3 py-5 backdrop-blur-sm"
            >
              <span className="font-heading text-2xl font-bold text-accent-200">{s.value}</span>
              <span className="mt-1.5 text-xs text-background-100/80">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#hot"
        aria-label="向下滚动"
        className="absolute bottom-6 left-1/2 hidden h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full text-background-100/70 transition-colors hover:text-background-50 md:flex"
      >
        <i className="ri-arrow-down-line animate-bounce text-xl" />
      </a>
    </section>
  );
}